class Extranet.Models.Payment extends Extranet.Model

  idAttribute: 'uuid'
